// extracted by mini-css-extract-plugin
export default {"modalContent":"FilesErrors_modalContent__cjxZp","fileTitle":"FilesErrors_fileTitle__yEi5E"};